import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=a0d3597a&scoped=true&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"
import style0 from "./MainBody.vue?vue&type=style&index=0&id=a0d3597a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d3597a",
  null
  
)

export default component.exports